import { useCallback } from 'react'
import { claimTradingReward } from 'utils/calls'
import { useTradingChef } from 'hooks/useContract'
import { useTransactionAdder } from 'state/transactions/hooks'
import useToast from 'hooks/useToast'

const useClaimReward = () => {
  const tradingChefContract = useTradingChef()

  const addTransaction = useTransactionAdder()

  const { toastError } = useToast()

  const handleClaim = useCallback(async (value: string) => {
    return claimTradingReward(tradingChefContract).then(async (response: any) => {

      const base = `Claim ${value} XOXO trading rewards`

      addTransaction(response, {
        summary: base,
      })

      return response
    })
      .catch((error: any) => {
        // if the user rejected the tx, pass this along
        if (error?.code === 4001) {
          toastError('Transaction rejected.')
          throw new Error('Transaction rejected.')
        } else {
          // otherwise, the error was unexpected and we need to convey that
          toastError(`Claim rewards failed: ${error.message}`)
          throw new Error(`Claim rewards failed: ${error.message}`)
        }
      })
  }, [tradingChefContract])

  return { onClaim: handleClaim }
}

export default useClaimReward
